export default {
  'deposit.accountName': 'Account Name',
  'deposit.accountNumber': 'Account Number',
  'deposit.currencyCode': 'Currency Code',
  'deposit.ledgerBal': 'Opening Ledger',
  'deposit.collectedBal': 'Current Ledger',
  'deposit.currentBal': 'Current Available',
  'deposit.closingBal': "Today's Opening Ledger",
  'deposit.closingAvailable': 'Closing Available',
  'deposit.availableBal': 'Current Available (CRS Suppressed)',
  'deposit.totalFundsAvailable': 'Adjusted Balance',
  'deposit.asOfDate': 'Balance As Of',
  'deposit.notAvailable': 'Not Available',
  'deposit.notPermitted': 'No accounts have been permitted',
  'deposit.BTRNotPermitted': 'BTR.ACCOUNTS.NOT.PERMITTED',
  'deposit.requestNotFound': 'Request not found',
  'deposit.timeoutMessage':
    'We are experiencing a delay in retrieving account balance information at this time, please use the Financial Overview Widget to view desired account information and check back here shortly.'
};
